module.exports = __webpack_public_path__ + "img/SKMJ_sky2.198fc7e3.png";